import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ArrowDownRightIcon, UserXIcon, TrendingDownIcon } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: ClockIcon,
    text: 'Los interesados se enfrían cuando la respuesta tarda'
  }, {
    icon: ArrowDownRightIcon,
    text: 'Sin un sistema de seguimiento, la gente se olvida de ti'
  }, {
    icon: UserXIcon,
    text: 'Atender todo manualmente te quita tiempo de crecer'
  }, {
    icon: TrendingDownIcon,
    text: 'Las ventas suben y bajan sin un sistema que las sostenga'
  }];
  return <section className="py-24 bg-navy-deep relative" data-id="element-149">
      <div className="max-w-7xl mx-auto px-6" data-id="element-150">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-151">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-152">
            <span className="block text-white mb-2" data-id="element-153">
              Tu Negocio Merece Crecer.
            </span>
            <span className="block text-muted text-2xl md:text-3xl font-medium" data-id="element-154">
              No tener un sistema te está haciendo perder dinero, o hace que tu
              negocio pueda estar estancado…
            </span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-155">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="card-glow p-8 flex items-start gap-5" data-id="element-156">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0" data-id="element-157">
                <problem.icon className="w-6 h-6 text-primary" data-id="element-158" />
              </div>
              <p className="text-lg text-white font-medium leading-relaxed pt-2" data-id="element-159">
                {problem.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}